<template>
    <div v-if="items!==null && items.length>0">
        <hr/>
        <div v-for="item in items" style="border-left: 1px solid gray; border-right: 1px solid gray; border-radius: 10px; padding: 4px;">
            <h3>{{item.title}}</h3>
            <div style="white-space:pre-line;">
                {{item.textMsg}}
            </div>
            <div v-for="child in item.childs" style="margin-left:16px;">
                <div style="white-space:pre-line;margin-left:8px;padding:5px;">
                    <div style="font-weight:bold;">{{child.title}}</div>
                    <div style="padding:5px;">{{child.textMsg}}</div>
                </div>
            </div>
        </div>
        <hr/>
    </div>
</template>
<script>
    export default {
        computed: {
            apiClient: function () {
                return this.mxnAgxApi.policiesApiClient;
            }
        },
        data: function () {
            return {
                items: []
            }
        },
        mounted: function () {
            var that = this;
            this.apiClient.getItemsPrms().done(function (data) {
                that.items = data;
            });
        }
    }
</script>